import {
	DealDetailsActionTypes,
} from 'Redux/actionTypes/index';

export const initialState = {
	attributeCodes: [],
	contractsList: [],
	contractsDurations: [],
	dataPlanDetails: {},
	dealInclusions: [],
	dealInclusionColors: {},
	dealList: [],
	primaryProductColors: [],
	primaryProduct: {},
	relatedDeals: [],
	secondaryProduct: {},
	secondaryProductColors: [],
	selectedApplicationType: {},
  selectedDealDetails: {}, // TODO: Dissolve into other props to remove duplication
	selectedPrimaryDeviceColor: {},
	selectedSecondaryDeviceColor: {},
	selectedDurationAndPrice: {},
	similarDeals: [],
	whiteListedRouters: [],
};

export default (state = initialState, { type, payload }) => {
	switch (type) {
		case DealDetailsActionTypes.SET_ALL_DEAL_DATA:
			return {
				...state,
				attributeCodes: payload.attributeCodes,
				contractsDurations: payload.contractsDurations,
				contractsList: payload.contractsList,
				dataPlanDetails: payload.dataPlanDetails,
				dealList: payload.dealList,
				dealInclusions: payload.dealInclusions,
				dealInclusionColors: payload.dealInclusionColors,
				primaryProductColors: payload.primaryProductColors,
				primaryProduct: payload.primaryProduct,
				relatedDeals: payload.relatedDeals,
				secondaryProduct: payload.secondaryProduct || {},
				secondaryProductColors: payload.secondaryProductColors || [],
				selectedDealDetails: payload.selectedDealDetails,
				selectedPrimaryDeviceColor: payload.selectedPrimaryDeviceColor,
				selectedSecondaryDeviceColor: payload.selectedSecondaryDeviceColor,
				similarDeals: payload.similarDeals || [],
			};

		case DealDetailsActionTypes.SET_APPLICATION_TYPE:
			return {
				...state,
				selectedApplicationType: payload
			};

		case DealDetailsActionTypes.SET_ATTRIBUTE_CODES:
			return {
				...state,
				attributeCodes: payload
			};
	
		case DealDetailsActionTypes.SET_CONTRACT_DURATIONS:
			return {
				...state,
				contractsDurations: payload
			};

		case DealDetailsActionTypes.SET_CONTRACT_TYPES:
			return {
				...state,
				contractsList: payload
			};
	
		case DealDetailsActionTypes.SET_DEAL_DETAILS: {

			const newDeal = Array.isArray(state.dealList)
					&& state.dealList.find((deal) => deal.sku === payload.dealSku)
					|| {};
			
			return {
				...state,
				selectedDealDetails: newDeal,
			};
		}

		case DealDetailsActionTypes.SET_DEAL_LIST:
			return {
				...state,
				dealList: payload,
			};
	
		case DealDetailsActionTypes.SET_DEVICE_COLOR:
			return {
				...state,
				selectedPrimaryDeviceColor: payload.primaryDeviceColor ?? state.selectedPrimaryDeviceColor,
				selectedSecondaryDeviceColor: payload.secondaryDeviceColor ?? state.selectedSecondaryDeviceColor,
			};
	
		case DealDetailsActionTypes.SET_DEVICE_COLOR_OPTIONS:
			return {
				...state,
				primaryProductColors: payload
			};
	
		case DealDetailsActionTypes.SET_DEVICE_DURATION_PRICE:
			return {
				...state,
				selectedDurationAndPrice: payload
			};

		case DealDetailsActionTypes.SET_INCLUSION_COLOR:
			return {
				...state,
				dealInclusionColors: {
					...state.dealInclusionColors,
					[payload.inclusionSku]: {
						...state.dealInclusionColors[payload.inclusionSku],
						selectedColor: payload.inclusionColor,
					}
				}
			};
		
		case DealDetailsActionTypes.SET_RELATED_DEALS:
			return {
				...state,
				relatedDeals: payload
			}

		case DealDetailsActionTypes.SET_WHITELISTED_ROUTERS:
			return {
				...state,
				whiteListedRouters: payload
			};
	
		default:
			return state;
	}
};
